import styled from "styled-components";

const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
    z-index: ${props => props.$zIndex || 1000};
    display: ${(props) => props.$isOpen ? 'flex' : 'none'}
`;

const ModalBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.clearGray};
  background-color: ${(props) => props.theme.colors.highClearGray};
  width: ${(props) => (props.isExtended ? "719px" : props.width || '355px')};
  height: ${(props) => (props.isExtended ? "228px" : "auto")};
  padding: 32px;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 32px;
  right: 32px;
  width: 16px;
  height: 16px;
  color: ${(props) => props.theme.colors.clearGray};
`;

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const ModalActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; 
`;

const ModalActionsWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-left: ${(props) => (props.isExtended ? "20%" : "0")};
  margin-right: ${(props) => (props.isExtended ? "20%" : "0")};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: ${(props) => (props.isExtended ? "0px" : "24px")}; 
`;

const ModalPreview = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;      
  justify-content: center;  
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.white}; 
  width: ${({ isMobile, isTablet, isDesktop }) => 
    isMobile ? '95%' : 
    isTablet ? '90%' : 
     'min(1300px, 90vw)'
  };
  height: ${({ isMobile, isTablet }) => 
    isMobile ? '90vh' : 
    isTablet ? '80vh' : 
    '475px'
  };
`;

const ModalPreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;      
  justify-content: center;
  width: ${({ isMobile, isTablet }) => 
    isMobile ? '95%' : 
    isTablet ? '95%' : 
    'min(1268px, calc(90vw - 32px))' 
  };
  height: ${({ isMobile, isTablet }) => 
    isMobile ? '90%' : 
    isTablet ? '90%' : 
    '443px'
  };
`;

const ModalPreviewHeader = styled.div`
  display: flex;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 100%;
`;

const ModalPreviewContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ isMobile, isTablet }) => 
    isMobile ? '95%' : 
    isTablet ? '90%' : 
    'min(1268px, calc(90vw - 32px))'
  };          
  height: ${({ isMobile, isTablet }) => 
    isMobile ? '90%' : 
    isTablet ? '85%' : 
    '410px'
  };          
  border-radius: 8px;     
  padding: ${({ isMobile, isTablet }) => 
    isMobile ? '20px' : 
    isTablet ? '30px' : 
    '40px 40px'
  };   
  gap: 10px;              
  background-color: ${(props) => props.theme.colors.highClearGray}; 
  margin: auto;
`;

const ModalPreviewContentSignature = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ isMobile, isTablet }) => 
    isMobile ? '90%' : 
    isTablet ? '80%' : 
    'min(680px, calc(90vw - 200px))'
  };         
  height: ${({ isMobile, isTablet }) => 
    isMobile ? '300px' : 
    isTablet ? '250px' : 
    '202px'
  };         
  gap: 10px;         
  padding: 20px;   
  background-color: ${(props) => props.theme.colors.white}; 
  margin: auto;
  overflow-y: auto;      

  // Scrollbar mini
  &::-webkit-scrollbar {
    width: 4px; 
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
  }

  img {
    max-width: 40px;
    max-height: 40px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`;

const BoldLabel = styled.label`
  ${props => props.theme.fonts.variant.semiBold()};
`;

export {
  ModalWrapper,
  ModalBox,
  CloseButtonWrapper,
  ModalActionsContainer,
  ModalActionsWrapper,
  ModalContentWrapper,
  ModalPreview,
  ModalPreviewContent,
  ModalPreviewHeader, 
  ModalPreviewWrapper,
  ModalPreviewContentSignature,
  BoldLabel
}